import { createAction, props } from '@ngrx/store';
import { NavigableNotification } from '../../types/NavigableNotification';

export const set = createAction('SET_ERRORS', props<{ notifications: NavigableNotification[] }>());
